import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SessionService } from 'src/app/services/session.service';
import { SectionService } from 'src/app/services/section.service';

@Component({
  selector: 'app-organization-setup-onboarding-modal',
  templateUrl: './organization-setup-onboarding-modal.component.html',
  styleUrls: ['./organization-setup-onboarding-modal.component.scss']
})
export class OrganizationSetupOnboardingModalComponent implements OnInit {

  orgName: string = '';
  orgId: number | null = null;
  isLoadingOrg: boolean = true;
  isSaving: boolean = false;
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private modalController: ModalController,
    private sessionService: SessionService,
    private sectionService: SectionService
  ) {}

  async ngOnInit() {
    try {
      const orgs: any[] = await this.sectionService.listOrgs();

      // Prioridade 1: org sem nome (name: null ou vazio) — aguardando onboarding
      let org = orgs?.find(o => !o.name || o.name.trim() === '');

      // Prioridade 2: fallback — primeira org disponível
      if (!org && orgs?.length) {
        org = orgs[0];
      }

      if (org) {
        this.orgId = org.id;
        if (org.name) {
          this.orgName = org.name;
        }
      } else {
        this.hasError = true;
        this.errorMessage = 'Nenhuma organização disponível. Entre em contato com o administrador.';
      }
    } catch (error) {
      console.error('[Onboarding] Erro ao buscar organizações:', error);
      this.hasError = true;
      this.errorMessage = 'Erro ao carregar organização. Tente novamente.';
    } finally {
      this.isLoadingOrg = false;
    }
  }

  onInput() {
    this.hasError = false;
    this.errorMessage = '';
  }

  async save() {
    const name = this.orgName?.trim();

    if (!name) {
      this.hasError = true;
      this.errorMessage = 'Por favor, insira o nome da organização';
      return;
    }

    if (name.length < 3) {
      this.hasError = true;
      this.errorMessage = 'O nome deve ter no mínimo 3 caracteres';
      return;
    }

    if (name.length > 100) {
      this.hasError = true;
      this.errorMessage = 'O nome deve ter no máximo 100 caracteres';
      return;
    }

    if (!this.orgId) {
      this.hasError = true;
      this.errorMessage = 'Nenhuma organização disponível. Entre em contato com o administrador.';
      return;
    }

    this.isSaving = true;

    try {
      const userId = this.sessionService.user?.id;

      // PUT /Section/org/:id — usa o id resolvido no ngOnInit
      await this.sectionService.renameOrganization(this.orgId, name, userId);

      if (this.sessionService.membership) {
        this.sessionService.membership.name = name;
        this.sessionService.membership.sectionName = name;
        this.sessionService.membership.sectionId = this.orgId;
      }

      await this.modalController.dismiss({ orgUpdated: true, name });

    } catch (error: any) {
      const status = typeof error === 'number' ? error : (error?.status || error?.response?.status);

      let msg = 'Erro ao salvar. Tente novamente.';

      if (status === 401) {
        msg = 'Sessão expirada. Faça login novamente.';
        await this.sessionService.logout();
      } else if (status === 403) {
        msg = 'Sem permissão para editar esta organização. Entre em contato com o administrador.';
      } else if (status === 404) {
        msg = 'Organização não encontrada.';
      } else if (status === 409) {
        msg = 'Já existe uma organização com este nome.';
      }

      this.hasError = true;
      this.errorMessage = msg;
    } finally {
      this.isSaving = false;
    }
  }

  async skip() {
    await this.modalController.dismiss({ skipped: true });
  }

  async logout() {
    await this.modalController.dismiss(null, 'logout');
    await this.sessionService.logout();
  }
}
